import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { SbAsins, SbCreative, SbCreativeType } from "@front/m19-api-client";
import { AssetsPreviewComponent } from "@m19-board/strategies/sb-create-strategy/creative-preview-list/assets-preview/assets-preview.component";
import { VideoPreviewComponent } from "@m19-board/strategies/sb-create-strategy/creative-preview-list/video-preview/video-preview.component";
import { AsinItemsPreviewComponent } from "@m19-board/strategies/sb-create-strategy/creative-preview-list/asin-items-preview/asin-items-preview.component";
import { VideoAsinPreviewComponent } from "@m19-board/strategies/sb-create-strategy/creative-preview-list/video-asin-preview/video-asin-preview.component";

export type CreativePreviewAssets = Pick<
  Partial<SbCreative>,
  "brandName" | "headline" | "logoAssetId" | "videoAssetId" | "storePageId" | "state" | "brandEntityId"
>;

@Component({
  selector: "app-creative-preview",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AssetsPreviewComponent, VideoPreviewComponent, AsinItemsPreviewComponent, VideoAsinPreviewComponent],
  templateUrl: "./creative-preview.component.html",
  host: {
    class: "block w-full",
  },
})
export class CreativePreviewComponent {
  readonly SbCreativeType = SbCreativeType;

  readonly creativeType = input.required<SbCreativeType>();
  readonly asins = input<SbAsins>();
  readonly assets = input<CreativePreviewAssets>();
  readonly focused = input<boolean>(false);
}
